// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2vP7D","choiceBoxes":"toolbarselects_choiceBoxes__1U2vO","simpleField":"toolbarselects_simpleField__1moZv"};